import React, { useState, useEffect, useCallback } from "react";
import "./partners.scss";
import { getRequest, postRequest } from "../../api/http";
import userServiceApi from "../../api/userServiceApi";
import { Button, Input, Space, Table, Modal, Spin, Card, Tooltip, Image } from "antd";
import { SearchOutlined } from "@ant-design/icons";

import { toast } from "react-toastify";
import restoreIcon from "../../assets/images/restore-icon.svg";
import detailsIcon from "../../assets/images/details-icon.svg";
import calender from "../../assets/images/calender-icon.svg";
import listView from "../../assets/images/list-view.svg";
import cardView from "../../assets/images/card-view.svg";
import listViewSelected from "../../assets/images/list-view-selected.svg";
import cardViewSelected from "../../assets/images/card-view-selected.svg";
import Line from "../line/index";
import DeleteModal from "../deleteModal/deleteModal";
import { inputFieldCharLimit } from '../../config/index'
import { truncate } from "../../utils/helper";


const Restore = ({ reload, reloadFunc }) => {
  const [softDeletedPartners, setSoftDeletedPartners] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showDetails, setShowDetails] = useState(false);
  const [partnerDetails, setPartnerDetails] = useState({});
  const [partnerId, setPartnerId] = useState();
  const [isModalRestoreOpen, setIsModalRestoreOpen] = useState(false);
  const [viewSelected, setViewSelected] = useState("card");

  const [searchTerm, setSearchTerm] = useState('')
  const [boolAF, setBoolAf] = useState(false);
  const [boolGL, setBoolGl] = useState(false);
  const [boolMS, setBoolMs] = useState(false);
  const [boolTZ, setBoolTz] = useState(false);
  const [af, setAf] = useState("");
  const [gl, setGl] = useState("");
  const [ms, setMs] = useState("");
  const [tz, setTz] = useState("");

  const fetchData = useCallback(async () => {
    try {
      setLoading(true);

      const response = await getRequest(userServiceApi.getSoftDelPartner(searchTerm, boolAF, boolGL, boolMS, boolTZ, af, gl, ms, tz));
      if (response) {
        setSoftDeletedPartners(response.data);
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      console.error("Error fetching data:", error);
    }
  }, [searchTerm, boolAF, boolGL, boolMS, boolTZ, af, gl, ms, tz]);


  const handleAF = () => {
    if (!boolAF) {
      setAf("A-F");
      setBoolAf(true);
    } else {
      setAf("");
      setBoolAf(false);
    }
  };

  const handleGL = () => {
    if (!boolGL) {
      setGl("G-L");
      setBoolGl(true);
    } else {
      setGl("");
      setBoolGl(false);
    }
  };

  const handleMS = () => {
    if (!boolMS) {
      setMs("M-S");
      setBoolMs(true);
    } else {
      setMs("");
      setBoolMs(false);
    }
  };

  const handleTZ = () => {
    if (!boolTZ) {
      setTz("T-Z");
      setBoolTz(true);
    } else {
      setTz("");
      setBoolTz(false);
    }
  };

  const calculateDaysLeft = (dateString) => {
    console.log(dateString, "date");
    if (!dateString) {
      return 30;
    }

    const deletionDate = new Date(dateString);
    const thirtyDaysAheadDate = new Date(deletionDate);
    // console.log(thirtyDaysAheadDate, "30 days ahead date");
    thirtyDaysAheadDate.setDate(thirtyDaysAheadDate.getDate() + 30);
    const currentDate = new Date();
    const timeDifference = thirtyDaysAheadDate - currentDate;
    const daysLeft = Math.max(
      0,
      Math.ceil(timeDifference / (1000 * 60 * 60 * 24))
    );

    // console.log(daysLeft);
    return daysLeft;
  };

  useEffect(() => {
    fetchData();
    // Reload should refetch without waiting on the search debounce.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reload]);

  useEffect(() => {
    const handler = setTimeout(() => {
      fetchData()
    }, 500)

    return () => {
      clearTimeout(handler);
    };
  }, [af, gl, ms, tz, searchTerm, fetchData]);

  const restorePartnerYes = () => {
    restorePartner(partnerId);
  };

  const restorePartner = async (partnerId) => {
    try {
      const response = await postRequest(
        userServiceApi.restorePartner(partnerId)
      );
      if (response) {
        fetchData();
        reloadFunc();
        setIsModalRestoreOpen(false);
        toast.success("Partner restored successfully");
      }
    } catch (error) {
      setIsModalRestoreOpen(false);
      toast.error("Error restoring a partner");
    }
  };

  const showDetailsHandler = (partner) => {
    setPartnerId(partner.id);
    setPartnerDetails(partner);
    setShowDetails(true);
  };

  const closeModalDetails = () => {
    setPartnerId("");
    setPartnerDetails({});
    setShowDetails(false);
  };

  const openRestoreModal = (partnerId) => {
    setPartnerId(partnerId);
    setIsModalRestoreOpen(true);
  };

  const closeRestoreModal = () => {
    setPartnerId("");
    setIsModalRestoreOpen(false);
  };

  const handleSearchChange = (e) => {

    setSearchTerm(e.target.value)

  }

  const columns = [
    {
      title: "Partner Details",
      dataIndex: "mediaLink",
      key: "mediaLink",
      render: (text, record) => (
        <div
          style={{
            display: "flex",
            justifyContent: "left",
            alignItems: "center",
            whiteSpace: "nowrap", textOverflow: 'ellipsis', overflow: 'hidden', maxWidth: '400px', minWidth: '300px',
          }}
        >
          <img src={record.mediaLink} alt="" style={{ height: 60, maxWidth: 100, marginRight: '10px' }} /> {truncate(record.name, 30)}
        </div>
      ),
    },
    // {
    //   title: " ",
    //   dataIndex: "name",
    //   key: "name",
    //   render: (text) => <div style={{ fontSize: "15px", whiteSpace: "nowrap", textOverflow: 'ellipsis', overflow: 'hidden', maxWidth: '300px' }}>{truncate(text, 30)}</div>,
    // },
    {
      title: "Site Name",
      dataIndex: "siteName",
      key: "siteName",
      render: (text) => <div style={{ fontSize: "15px", whiteSpace: "nowrap", textOverflow: 'ellipsis', maxWidth: '300px' }}>{truncate(text, 20)}</div>,
    },
    {
      title: "Time Left for permanent deletion",
      key: "action",
      render: (text, record) => (
        <div
          style={{
            fontSize: "15px",
            fontWeight: "bold",
            // textAlign: "center",
            color: "#CC0E2D",
          }}
        >
          {` ${calculateDaysLeft(record.partnerDeletedAt)} days`}
        </div>
      ),
    },
    {
      title: " ",
      key: "action",
      render: (text, record) => (
        <Space size="middle" style={{ height: 60 }}>
          <img
            style={{ height: "25px" }}
            src={detailsIcon}
            alt="Details"
            onClick={() => showDetailsHandler(record)}
            title="Preview"
          />
          <div className="line" />
          <img
            src={restoreIcon}
            alt="Restore"
            onClick={() => openRestoreModal(record.id)}
            title="Restore"
          />
        </Space>
      ),
    },
  ];

  console.log('partnerDetails', partnerDetails)
  return (
    <>
      {
        <div className="main-container">
          <div className="filters-container">
            <div className="partner-heading">Partners</div>
            <div className="buttons">

              <div className="searchbar-containers">
                <Tooltip placement="top" title='Allowed: letters, numbers, spaces, hyphens (-), and underscores (_).'>
                  <Input
                    className="searchbar"
                    placeholder="Search Partners"
                    value={searchTerm}
                    suffix={
                      <SearchOutlined
                        style={{ color: "#CC0E2D", verticalAlign: "middle" }}
                      />
                    }
                    onPressEnter={(e) => handleSearchChange(e)}
                    onChange={handleSearchChange}
                    maxLength={inputFieldCharLimit}
                  />
                </Tooltip>
              </div>
              <Line />
              <div className="alphabets-filter">
                <Button
                  id="A-F-btn"
                  className={`${!boolAF
                    ? "alpha-filter-btn first-btn"
                    : "alpha-filter-btn-select first-btn"
                    }`}
                  onClick={handleAF}
                >
                  <span className="alphas">A-F</span>
                </Button>
                <Button
                  id="G-L-btn"
                  className={`${!boolGL ? "alpha-filter-btn" : "alpha-filter-btn-select"
                    }`}
                  onClick={handleGL}
                >
                  <span className="alphas">G-L</span>
                </Button>
                <Button
                  id="M-S-btn"
                  className={`${!boolMS ? "alpha-filter-btn" : "alpha-filter-btn-select"
                    }`}
                  onClick={handleMS}
                >
                  <span className="alphas">M-S</span>
                </Button>
                <Button
                  id="T-Z-btn"
                  className={`${!boolTZ ? "alpha-filter-btn" : "alpha-filter-btn-select"
                    }`}
                  onClick={handleTZ}
                >
                  <span className="alphas">T-Z</span>
                </Button>
              </div>
              <Line />
              {viewSelected === "list" ? (
                <img src={listViewSelected} alt="listviewSelected" />
              ) : (
                <img
                  src={listView}
                  alt="listview"
                  style={{ cursor: "pointer" }}
                  onClick={() => setViewSelected("list")}
                />
              )}
              <Line />
              {viewSelected === "card" ? (
                <img src={cardViewSelected} alt="cardViewSelected" />
              ) : (
                <img
                  src={cardView}
                  alt="cardView"
                  style={{ cursor: "pointer" }}
                  onClick={() => setViewSelected("card")}
                />
              )}
            </div>
          </div>

          {
            loading ? (
              <Spin className="data-loader loading-svg" tip="Loading" size="large" />
            ) :

              viewSelected === "list" ? (
                <div className="table-view-deleted">
                  {softDeletedPartners.length > 0 ? (
                    <Table
                      rowClassName={() => "rowClassName1"}
                      dataSource={softDeletedPartners}
                      columns={columns}
                    />
                  ) : (
                    <h3 className="placeholder" style={{ textAlign: "center", margin: "50px 0" }}>No partners available</h3>
                  )}

                </div>
              ) : (
                <div
                  className="partner-list-container"
                  style={softDeletedPartners && softDeletedPartners.length === 0 ? { display: 'block' } : null}
                >
                  {softDeletedPartners.length > 0 ? (
                    softDeletedPartners?.map((partner) => (
                      <Card className="partner-card" key={partner.id} size="small">
                        <div className="card-header-container">
                          <div className="card-heading" style={{
                            // maxWidth: "200px",
                            whiteSpace: 'nowrap',
                            textOverflow: "ellipsis",
                          }} >{truncate(partner.name, 25)}</div>
                          <div className="icons-stack">
                            <img
                              src={detailsIcon}
                              alt="detailsIcon"
                              style={{ marginRight: "5px", height: "25px" }}
                              onClick={() => showDetailsHandler(partner)}
                              title="Preview"
                            />
                            <Line />
                            <img
                              src={restoreIcon}
                              // style={{ height: "25px" }}
                              alt="editIcon"
                              style={{ margin: "0px 5px 0px 5px " }}
                              onClick={() => openRestoreModal(partner.id)}
                              title="Restore"
                            />
                          </div>
                        </div>
                        <div className="card-main-container">
                          <div className="partner-logo-container">
                            <img src={partner.mediaLink} alt={partner.name} />
                            <div className="site-name" style={{
                              width: '300px',
                              whiteSpace: 'nowrap',
                              textOverflow: "ellipsis",
                              overflow: "hidden"
                            }}>{truncate(partner.siteName, 25)}</div>
                          </div>
                          <div className="partner-configurations-container-restore">
                            <img src={calender} alt="calender-icon" />
                            <span className="days-left">{`${calculateDaysLeft(
                              partner.partnerDeletedAt
                            )}`}</span>{" "}
                            Days to Restore
                          </div>
                        </div>
                      </Card>
                    ))
                  ) : (
                    <h3 className="placeholder" style={{ textAlign: "center", margin: "50px 0" }}>No partners available</h3>
                  )}
                </div>
              )
          }
        </div>
      }

      <DeleteModal
        openModal={isModalRestoreOpen}
        message="Are you sure you want to restore this partner?"
        yesClick={restorePartnerYes}
        closeModal={closeRestoreModal}
      />

      <Modal
        title="Partner Details"
        visible={showDetails}
        onCancel={closeModalDetails}
        footer={null}
        width={800}
      >

        <div className="partnerDetailsPreview">
          {partnerDetails?.name && (
            <div className="partnerDetailsPreviewRow">
              <div className="partnerDetailsPreviewCol">Partner Name</div>
              <div className="partnerDetailsPreviewCol">{partnerDetails.name}</div>
            </div>
          )}
          {partnerDetails?.email && (
            <div className="partnerDetailsPreviewRow">
              <div className="partnerDetailsPreviewCol">Email</div>
              <div className="partnerDetailsPreviewCol">{partnerDetails?.email}</div>
            </div>
          )}
          {partnerDetails?.mobileNumber && (
            <div className="partnerDetailsPreviewRow">
              <div className="partnerDetailsPreviewCol">Mobile Number</div>
              <div className="partnerDetailsPreviewCol">{partnerDetails?.mobileNumber}</div>
            </div>
          )}
           {partnerDetails?.siteName && (
            <div className="partnerDetailsPreviewRow">
              <div className="partnerDetailsPreviewCol">Site Name</div>
              <div className="partnerDetailsPreviewCol">{partnerDetails?.siteName}</div>
            </div>
          )}
           {partnerDetails?.address && (
            <div className="partnerDetailsPreviewRow">
              <div className="partnerDetailsPreviewCol">Address</div>
              <div className="partnerDetailsPreviewCol">{partnerDetails?.address}</div>
            </div>
          )}
          {partnerDetails?.mediaLink && (
            <div className="partnerDetailsPreviewRow">
              <div className="partnerDetailsPreviewCol">Media</div>
              <div className="partnerDetailsPreviewCol"><Image src={partnerDetails?.mediaLink} preview={false} width={60} /></div>
            </div>
          )}
          {partnerDetails?.subDomainName && (
            <div className="partnerDetailsPreviewRow">
              <div className="partnerDetailsPreviewCol">Sub Domain</div>
              <div className="partnerDetailsPreviewCol">{partnerDetails?.subDomainName}</div>
            </div>
          )}
          {/* {partnerDetails?.appName && (
            <div className="partnerDetailsPreviewRow">
              <div className="partnerDetailsPreviewCol">Site Name</div>
              <div className="partnerDetailsPreviewCol">{partnerDetails?.appName}</div>
            </div>
          )} */}
          {partnerDetails?.appLogo && (
            <div className="partnerDetailsPreviewRow">
              <div className="partnerDetailsPreviewCol">Site Logo</div>
              <div className="partnerDetailsPreviewCol"><Image src={partnerDetails?.appLogo} preview={false} width={60} /></div>
            </div>
          )}


          {/* {partnerDetails?.description && (
            <div className="partnerDetailsPreviewRow">
              <div className="partnerDetailsPreviewCol">Description</div>
              <div className="partnerDetailsPreviewCol">{partnerDetails?.description}</div>
            </div>
          )}
          {partnerDetails?.website && (
            <div className="partnerDetailsPreviewRow">
              <div className="partnerDetailsPreviewCol">Website</div>
              <div className="partnerDetailsPreviewCol">{partnerDetails?.website}</div>
            </div>
          )}
          {partnerDetails?.twitterHandle && (
            <div className="partnerDetailsPreviewRow">
              <div className="partnerDetailsPreviewCol">Twitter</div>
              <div className="partnerDetailsPreviewCol">{partnerDetails?.twitterHandle}</div>
            </div>
          )}
          {partnerDetails?.partnerType && (
            <div className="partnerDetailsPreviewRow">
              <div className="partnerDetailsPreviewCol">Partner Type</div>
              <div className="partnerDetailsPreviewCol">{partnerDetails?.partnerType}</div>
            </div>
          )}
          {partnerDetails?.wallpaper && (
            <div className="partnerDetailsPreviewRow">
              <div className="partnerDetailsPreviewCol">Wallpaper</div>
              <div className="partnerDetailsPreviewCol"><Image src={partnerDetails?.wallpaper} preview={true} width={100} /></div>
            </div>
          )} */}

        </div>

        {/* <pre>{JSON.stringify(partnerDetails, null, 2)}</pre> */}
        {/* <p>ID: {partnerDetails.id}</p> */}
        {/* <div style={{ marginTop: 20 }}>
          <p>Name: {partnerDetails?.name}</p>
          <p>Address: {partnerDetails?.address}</p>
          <p>Website: {partnerDetails?.website}</p>
          <p>Twitter: {partnerDetails?.twitterHandle}</p>
          <p>Description: {partnerDetails?.description}</p>
          <p>Sitename: {partnerDetails?.siteName}</p>
        </div> */}
      </Modal>
    </>
  );
};

export default Restore;
